import { AxiosResponse } from 'axios';
import { FamilyVM } from 'practice/components/edit/form/step-family/family/table-family';
import { HttpResponse } from 'shell/models/http-response';
import { DateTime } from 'luxon';
import { transformGenerality } from 'shell/utils/consult-person/response-transformer/registry-office/generality';
import { SubjectsList } from 'shell/models/person';
import { ResidenceOriginTransformer } from '../../shell/components/shared/sipo-person-form/transformer-person-to-register-office';

export const transformPersonFamily = (
  response: AxiosResponse<HttpResponse<SubjectsList>>
): Array<FamilyVM> => {
  const data = response.data.payload || {};

  return (data.datiSoggetto || []).map((subject) => ({
    surname: subject.generalita?.cognome || '',
    name: subject.generalita?.nome || '',
    fiscalCode: subject.generalita?.codiceFiscale?.codFiscale || '',
    cfControl: '1',
    birthDate: subject.generalita?.dataNascita
      ? DateTime.fromISO(subject.generalita?.dataNascita).toFormat('dd/MM/yyyy')
      : '',
    relationship: subject.legameSoggetto?.codiceLegame || '',
    birthplace:
      (subject.generalita?.luogoNascita?.localita
        ? subject.generalita?.luogoNascita?.localita?.descrizioneStato
        : subject.generalita?.luogoNascita?.comune?.nomeComune) || '',
    residence: `${
      (subject?.residenza || [])[0]?.indirizzo?.toponimo?.denominazioneToponimo || ''
    }, ${(subject?.residenza || [])[0]?.indirizzo?.numeroCivico?.numero || ''} ${
      (subject?.residenza || [])[0]?.indirizzo?.numeroCivico?.esponente1 ||
      (subject?.residenza || [])[0]?.indirizzo?.numeroCivico?.lettera
        ? `/${(subject?.residenza || [])[0]?.indirizzo?.numeroCivico?.esponente1 || ''}${
            (subject?.residenza || [])[0]?.indirizzo?.numeroCivico?.lettera || ''
          }`
        : ''
    }`,
    drivingLicense: subject.autoveicoli?.possessoPatente || '',
    isSipo:
      Boolean(
        subject?.generalita?.idSchedaSoggettoComune?.idSchedaSoggetto &&
          !subject?.generalita?.idSchedaSoggettoANPR
      ) ||
      (subject?.datiCancellazione &&
        subject?.datiCancellazione.motivoCancellazione?.toString() === '6'),
    auto: subject.autoveicoli?.possessoAutoveicoli || '',
    aire: subject.generalita?.soggettoAIRE || '',
    subject,
    generality: transformGenerality(subject),
    residenceOrigin: ResidenceOriginTransformer(subject),
  })) as Array<FamilyVM>;
};
